import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Grid2,
  Paper,
  Typography,
  useTheme,
  Button,
  TextField,
  Stack,
} from "@mui/material";
import { useDispatch } from "store";
import { useGetFileUploadsQuery } from "store/slices/apis/fileUploadSlice";
import moment from "moment";
import TableComponent from "components/grid";
import { useParams } from "react-router-dom";
import PaginationComponent from "components/ui-components/PaginationComponent";
import FileUploadModal from "components/FileUpload";
import { API_END_POINT } from "config";
import AddIcon from "@mui/icons-material/Add";
import { IoMdSearch } from "react-icons/io";
import { usePermission } from "hooks/usePermission";
import { FILE_VIEW } from "config";
import {ReactComponent as AddNewIcon} from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"


const columns = [
  {
    name: "File Name",
    field: "name",
    renderer(params) {
      const fileName = params?.name;
      if (fileName && fileName?.includes("_")) {
        const splitName = fileName?.split("_");
        const lastPart = splitName?.slice(1).join("_");
        return <>{lastPart}</>;
      } else {
        return <>{fileName}</>;
      }
    },
  },
  {
    name: "Uploaded At",
    field: "createdDate",
    renderer(params) {
      return (
        <>
          {params?.createdDate
            ? moment(params.createdDate).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Status",
    field: "status",
  },
  {
    name: "Action",
    field: "action",
    option: {},
  },
];
const fileTypes = [
  { label: "Milestone", value: "Milestone" },
  { label: "WBS", value: "WBS" },
  { label: "Manpower", value: "Manpower" },
  { label: "P&M", value: "P&M" },
  { label: "BOQ", value: "BOQ" },
  { label: "Payment Tracker", value: "PaymentTracker" },
  { label: "Purchase Order", value: "PurchaseOrder" },
];

const AllFilesList = () => {
  const theme = useTheme();
  const [pageNumber, setPageNumber] = useState(1);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [fileType, setfileType] = useState("");
  const [filters, setFilters] = useState({
    fileType: "",
  });
  const dispatch = useDispatch();
  const fileViewAccess = usePermission(FILE_VIEW)
  const { projectId } = useParams();
  const { data, isLoading, refetch } = useGetFileUploadsQuery({
    projectId,
    page: pageNumber,
    pageSize: "10",
    type: filters?.fileType,
  });

  useEffect(() => {
    refetch();
  }, []);

  const handleActionView = (id) => {
    window.open(`${API_END_POINT}issues/view/${id?.name}`, "_blank");
  };

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <Autocomplete
                options={fileTypes}
                getOptionLabel={(option) => option?.label}
                onChange={(_, newValue) =>
                  setfileType(newValue ? newValue?.value : "")
                }
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    paddingTop: "8px !important",
                    paddingBottom: "7px !important",
                    paddingRight: "0px !important",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="File Type"
                    name="fileType"
                    variant="outlined"
                    size="small"
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#fff",
                      },
                      minWidth: "230px",
                      marginTop: "12px",
                    }}
                  />
                )}
                ListboxProps={{
                  sx: { fontSize: "13px" },
                }}
              />

              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({ fileType });
                }}
                size="large"
                // startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill:`${theme?.customSettings?.themeColor}` }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
            </Stack>

            <Button
              variant="contained"
              onClick={() => setFileUploadModal(!fileUploadModal)}
              // startIcon={<AddIcon sx={{ marginBottom: "2px" }} />}
              startIcon={<AddNewIcon style={{ height: "20px", width: "20px", fill: "#FFFFFF" }}  />}
              sx={{
                backgroundColor: `${theme?.customSettings?.themeColor}`,
                color: "#FFF",
                padding: "5px 20px",
                fontWeight: "500",
                textTransform: "none",
                fontSize: "16px",
                marginTop: "11px",
                border: `1px solid ${theme?.customSettings?.themeColor}`,
              }}
            >
              File Upload
            </Button>
            <FileUploadModal
              fileUploadModal={fileUploadModal}
              setFileUploadModal={setFileUploadModal}
              fileType={fileType}
              refetch={refetch}
            />
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: fileViewAccess,
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={data?.data?.pagedFiles}
            actionView={handleActionView}
          />
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <PaginationComponent
              pageNumber={data?.data?.page || 1}
              totalPages={
                Math.ceil(data?.data?.totalRecords / data?.data?.pageSize) || 1
              }
              onPageChange={setPageNumber}
            />
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
};

export default AllFilesList;
